import Vue from 'vue'
import Form from '@/agilis/components/Form/Form.vue'

// Pubblicazione componenti UI di uso comune per evitare gli import e semplificare
// la gestione di dipendenze circolari in caso di import incrociati
Vue.component('Form', Form)
